<template>
  <div>
    <slot
          :news="news"
          :isAjax="isAjax"
          :allShown="allShown"
          :debounce="debounce"
          :loadMore="loadMore"
    >
    </slot>
  </div>
</template>


<script>
import tools from "../mixins/tools";

export default {
  name   : "NewsSection",
  mixins : [tools],
  props  : {
    items  : {
      type    : Array,
      default : () => []
    },
    navNum : Number,
    pages  : Number
  },
  data()
  {
    return {
      isAjax   : false,
      news     : [],
      nextPage : 2,
      allShown : false
    };
  },
  methods : {
    fillNews( items )
    {
      for(let key in items)
        this.news.push(items[key]);
    },
    loadMore()
    {

      if(this.allShown)
      {
        return;
      }
      let query = (document.location.search === "" ? "?" : "&") + "pagination=Y&PAGEN_" + this.navNum + "=" + this.nextPage;
      fetch(document.location.href + query, {
        method : "GET"
      })
      .then(response => response.json())
      .then(result =>
      {
        if(result.data.length > 0)
        {
          this.fillNews(result.data);
        }
        this.nextPage++;
        if(this.pages < this.nextPage)
        {
          this.allShown = true;
        }
      });
    }
  },
  created()
  {
    this.news     = this.items;
    this.allShown = this.pages < this.nextPage;
    this.isAjax = true;
  }
};
</script>